import { Reducer } from 'redux';
import { OrdersSchoolState, OrdersSchoolTypes } from './types';

export const INITIAL_STATE: OrdersSchoolState = {
  ordersSchoolList: [],
  orderSchoolData: {
    payment: {
      type: '',
      data: {},
    },
    orders: [],
  },
  chargeRequestSchoolList: [],
  chargeRequestSchoolData: {
    id: '',
    userId: '',
    type: '',
    ChargeRequestOrders: [],
    status: 0,
    value: 0,
    nsu: null,
    PaymentRequest: {
      id: '',
      type: '',
      status: 0,
      value: 0,
      tax: 0,
      data: {},
      createdAt: '',
      updatedAt: '',
      chargeRequestId: '',
      PaymentRequestHistories: [],
    },
    createdAt: '',
    updatedAt: '',
    ChargeRequestHistories: [],
  },
  chargeRequestRepeatSchoolData: {
    id: '',
    userId: '',
    type: '',
    ChargeRequestOrders: [],
    status: 0,
    value: 0,
    nsu: null,
    PaymentRequest: {
      id: '',
      type: '',
      status: 0,
      value: 0,
      tax: 0,
      data: {},
      createdAt: '',
      updatedAt: '',
      chargeRequestId: '',
      PaymentRequestHistories: [],
    },
    createdAt: '',
    updatedAt: '',
    ChargeRequestHistories: [],
  },
  totalCount: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<OrdersSchoolState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES GET ORDER SCHOOL
    case OrdersSchoolTypes.GET_ORDER_SCHOOL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chargeRequestSchoolData: INITIAL_STATE.chargeRequestSchoolData,
      };
    case OrdersSchoolTypes.GET_ORDER_SCHOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestSchoolData: action.payload.chargeRequestSchoolData,
      };
    case OrdersSchoolTypes.GET_ORDER_SCHOOL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chargeRequestSchoolData: INITIAL_STATE.chargeRequestSchoolData,
      };

    // LIST ORDERS SCHOOL
    case OrdersSchoolTypes.LIST_ORDERS_SCHOOL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chargeRequestSchoolList: INITIAL_STATE.chargeRequestSchoolList,
      };
    case OrdersSchoolTypes.LIST_ORDERS_SCHOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestSchoolList: action.payload.chargeRequestSchoolList,
        totalCount: action.payload.totalCount,
      };
    case OrdersSchoolTypes.LIST_ORDERS_SCHOOL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chargeRequestSchoolList: INITIAL_STATE.chargeRequestSchoolList,
      };

    // CREATE ORDER
    case OrdersSchoolTypes.CREATE_ORDER_SCHOOL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chargeRequestSchoolData: INITIAL_STATE.chargeRequestSchoolData,
      };
    case OrdersSchoolTypes.CREATE_ORDER_SCHOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestSchoolData: action.payload.chargeRequestSchoolData,
      };
    case OrdersSchoolTypes.CREATE_ORDER_SCHOOL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chargeRequestSchoolData: INITIAL_STATE.chargeRequestSchoolData,
      };

    // REPEAT ORDER
    case OrdersSchoolTypes.CHARGE_REQUEST_REPEAT_ORDER_SCHOOL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chargeRequestRepeatSchoolData:
          INITIAL_STATE.chargeRequestRepeatSchoolData,
      };
    case OrdersSchoolTypes.CHARGE_REQUEST_REPEAT_ORDER_SCHOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestRepeatSchoolData:
          action.payload.chargeRequestRepeatSchoolData,
      };
    case OrdersSchoolTypes.CHARGE_REQUEST_REPEAT_ORDER_SCHOOL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chargeRequestRepeatSchoolData:
          INITIAL_STATE.chargeRequestRepeatSchoolData,
      };

    // DELETE_CHARGE_REQUEST_SCHOOL_REQUEST
    case OrdersSchoolTypes.DELETE_CHARGE_REQUEST_SCHOOL_REQUEST:
      return { ...state, loading: true, error: false };
    case OrdersSchoolTypes.DELETE_CHARGE_REQUEST_SCHOOL_SUCCESS:
      return { ...state, loading: false, error: false };
    case OrdersSchoolTypes.DELETE_CHARGE_REQUEST_SCHOOL_FAILURE:
      return { ...state, loading: false, error: false };

    default:
      return { ...state };

    // FILTER ORDERS
    case OrdersSchoolTypes.FILTER_ORDER_SCHOOL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chargeRequestSchoolList: INITIAL_STATE.chargeRequestSchoolList,
      };
    case OrdersSchoolTypes.FILTER_ORDER_SCHOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestSchoolList: action.payload.chargeRequestSchoolList,
      };
    case OrdersSchoolTypes.FILTER_ORDER_SCHOOL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chargeRequestSchoolList: INITIAL_STATE.chargeRequestSchoolList,
      };
  }
};

export default reducer;
